export default __webpack_public_path__ + "static/media/resume.326a0f04.pdf";